const __WEBPACK_NAMESPACE_OBJECT__ = {"NODE_ENV":"production","APP":"AvidCarp"};